var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Nav'),_c('main',[_c('router-view')],1),_c('footerBox'),_c('a-back-top',[_c('div',{staticClass:"ant-back-top-inner"},[_c('img',{attrs:{"src":require("./assets/images/logo/滑向顶部@2x.png"),"alt":""}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }